module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEI8Fh6gAAAABnRSTlMAIJ/vADDOI35WAAAA70lEQVR4Xu3RQUpDQRQF0VqDcQMiZB7FPxfKFSRuIA29/yUo+WTQ3Ef3OJAaPi5n8njEnr1s7U2c9rP13i447dz/O7GEer+yhnpjAd1iBeWohhquoStrqJ9YQ+3CGvoS15CsIcXbn6eQ7H+eQnLYyRkkx92cQbLt6AySuzqB5M5OINmCCkiOQQUkh0EuIYlLQhJ2QhJ4QhJ6QhJ8QjL4NSTDvYbEgSohcaBKSByo3woSB+qzgsSB6hUkDlQJiUEFJAYVkBhUQGJQAYlBBSQGFZAYVEDiQJWQOFAlJA5UQCF5TihH3+/949UMowcZPaU/cXZ+4uBvhekAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2714.png
// module id = 1395
// module chunks = 0